"use client";

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, createContext, use } from "react";
import type { UseCommentThreadApi } from "@/components/Comment/hooks/use-comment-thread.hook";
import type { CommentModel } from "@/services/api/comment/models/comment.model.types";
type CommentContextValue = {
  readonly comment: CommentModel;
  readonly thread: UseCommentThreadApi;
  readonly depth: number;
};
const CommentContext = createContext<CommentContextValue | null>(null);
export function useComment(): CommentContextValue {
  const context = use(CommentContext);
  if (!context) {
    throw new Error("useComment must be used within a CommentProvider");
  }
  return context;
}
type CommentProviderProps = {
  readonly children: ReactNode;
  readonly value: CommentContextValue;
};
export function CommentProvider(t0) {
  const $ = _c(3);
  const {
    children,
    value
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== value) {
    t1 = <CommentContext value={value}>{children}</CommentContext>;
    $[0] = children;
    $[1] = value;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}